export const CURRENT_STATUS = {
  IN_PROGRESS: 'In-Progress',
  DIAGNOSIS_COMPLETED: 'Diagnosis Completed',
  APPROVED_FOR_DESIGN: 'Approved for Design',
  CANCELLED: 'Cancelled',
  RESTARTED: 'Restarted',
  SOLUTION_SELECTED: 'Solutions Selected',
} as const;

export type StatusKeys = (typeof CURRENT_STATUS)[keyof typeof CURRENT_STATUS];

export const STATUS_CLASS_MAPPING: { [key: string]: string } = {
  'In-Progress': 'in-progress',
  'Approved for Design': 'approved',
  'Diagnosis Completed': 'diagnosis-completed',
  'Solutions Selected': 'solutions-selected',
  Cancelled: 'cancelled',
  Restarted: '',
};

export const ACTIVE_STATUS = [
  { name: 'Active', value: true },
  { name: 'Inactive', value: false },
];

export const COMPATIBLE_VALUE = {
  NOT_RELEVANT: 'Not Relevant',
  COMPATIBLE: 'Compatible',
  NOT_COMPATIBLE: 'Not Compatible',
  ADD_SYNERGYS: 'Adds Synergy',
  NOT_IDEAL: 'Not Ideal',
};
